import { render, staticRenderFns } from "./ZWhatsappSvg.vue?vue&type=template&id=097a504a&scoped=true&"
import script from "./ZWhatsappSvg.vue?vue&type=script&lang=js&"
export * from "./ZWhatsappSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a504a",
  null
  
)

export default component.exports